import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgFilledWarning = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M1.5 21H23.5L12.5 2L1.5 21ZM13.5 18H11.5V16H13.5V18ZM13.5 14H11.5V10H13.5V14Z", fill: "#FFAE00" }) });
const ForwardRef = forwardRef(SvgFilledWarning);
export { ForwardRef as ReactComponent };
